// =====================================
//
//   Footer
//   Author: Gray
//   createtime: 2016 / 02 / 17
//   updatetime: 2016 / 02 / 17
//
// =====================================

window.InifECApp.directive('community', ['$rootScope', function($rootScope) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

    	var init = function() {

    	}

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();

	}];

	_dir.restrict = 'E';
	_dir.scope = true;
	_dir.templateUrl = "partials/directives/community.html";
	_dir.controller = controller;

	return _dir;

}]);
